<script lang="ts">
    import { onDestroy } from 'svelte';
    import Regex from '../../lib/regex';

    export let name: string;
    export let errors: Record<string, string[]>;
    export let label: string = '';
    export let value: string = '';
    export let disabled: boolean = false;

    errors[name] = [];

    const validate = (val: string = value) => {
        errors[name] = [];
        if (val && !Regex.MAC.test(val)) {
            errors[name].push('Invalid MAC address (AA:BB:CC:DD:EE:FF)');
        }
    };
    validate();

    const handleInput = (e: Event) => {
        const raw = (e.currentTarget as HTMLInputElement).value.replace(/[^0-9A-Fa-f]/g, '');
        const groups = raw.match(/.{1,2}/g) ?? [];
        value = groups.join(':').slice(0, 17);
        validate(value);
    };

    onDestroy(() => { errors[name] = []; });
</script>

<label class="form-field">
    {#if label}<span class="label-text">{label}</span>{/if}
    <input
        type="text"
        {name}
        {disabled}
        value={value}
        on:input={handleInput}
        class="input-mono"
        class:error={errors[name].length > 0}
        placeholder="AA:BB:CC:DD:EE:FF"
        maxlength="17"
        on:change
        on:blur
    />
    <span class="field-errors">
        {#each errors[name] as err}<span>{err}</span>{/each}
    </span>
</label>
